import { render, staticRenderFns } from "./alarmManagement.vue?vue&type=template&id=24910f17&"
import script from "./alarmManagement.vue?vue&type=script&lang=js&"
export * from "./alarmManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports